export function calculatePricing(companyData?: Record<string, string>): {
  needCustomPlan: boolean
  monthlyPrice: number
  annualPrice: number
  amountSaved: number
  min: string
  max: string
} {
  if (!companyData) {
    return { needCustomPlan: false, monthlyPrice: 0, annualPrice: 0, amountSaved: 0, min: '', max: '' }
  }

  const { min, max } = JSON.parse(companyData.employees) as { min: string; max: string }

  const needCustomPlan = min === '50+'

  if (needCustomPlan) {
    return { needCustomPlan, monthlyPrice: 0, annualPrice: 0, amountSaved: 0, min: '', max: '' }
  }

  const averageEmployee = (parseInt(min) + parseInt(max)) / 2
  const monthlyPrice = averageEmployee * 20
  const annualPrice = monthlyPrice * 12 * 0.9
  const amountSaved = monthlyPrice * 12 - annualPrice

  return { needCustomPlan, monthlyPrice, annualPrice, amountSaved, min, max }
}
